import * as React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import AuthService from 'api/Auth';
import { RoutePaths, RouteList, IRoute } from "./RouteConfig"

import NotFound from "views/Public/NotFound";
import ErrorPage from 'views/Public/ErrorPage';

class Routes extends React.Component {
    render() {
        return (
            <Switch>
                {
                    RouteList.map((v, index) => {
                        if (v.redirect)
                            return <Redirect from={v.path} to={v.redirect} exact />
                        else
                            if (v.public) {
                                return v.layout
                                    ? (<LayoutRoute {...v} key={index} />)
                                    : (<Route path={v.path} exact={v.exact} component={v.component} key={index} />)
                            }
                            else
                                return (<AuthenticatedRoute {...v} key={index} />)
                    })
                }
                <Redirect from="/" to={RoutePaths.TimelineStartup} exact />
                <Route path="/showError/:code?" component={ErrorPage} />
                <Route path="*" component={NotFound} exact />
            </Switch>
        );
    }
}

const AuthenticatedRoute: React.FC<IRoute> = ({ component, layout, ...rest }) => (
    <Route
        {...rest}
        render={props => (
            AuthService.isSignedIn()
                ? (layout
                    ? (<LayoutRoute {...rest} component={component} layout={layout} />)
                    : (<Route {...rest} component={component} />)
                )
                : (
                    <Redirect to={{ pathname: RoutePaths.Login, state: { from: props.location } }} />
                )
        )}
    />
);

const LayoutRoute: React.FC<IRoute> = ({ component, layout: Layout, ...rest }) => (
    <Route
        {...rest}
        render={props => (<Layout {...props} {...rest} component={component} />)}
    />

);


export default Routes;